export default __webpack_public_path__ + "static/media/Content_mentor .3f9b8af9.png";